import axios from 'axios';
import { getToken } from 'lib/auth/authUtils';
import { getIdToken } from 'lib/auth/tokenStore';
import { env } from 'config/env';

export const BASE_URL = env.apiUrl;

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor — attach Zitadel access token for auth, plus the
// id_token in X-ID-Token so the backend can read native profile claims
// (email, given_name, family_name, phone_number).
apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const idToken = getIdToken();
  if (idToken) {
    config.headers['X-ID-Token'] = idToken;
  }
  return config;
});

// Response interceptor — log 401s but don't auto-redirect.
// Zitadel manages the session; a 401 means the backend rejected our token,
// which the user should see (not get bounced through an infinite redirect).
apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default apiClient;
